export {
  Medal as Acknowledgements,
  Plus as Add,
  PlusSquare as AddSquare,
  AlertCircle,
  AlignCenter,
  AlignLeft,
  AlignRight,
  Archive,
  ArrowDownRight,
  ArrowDownUp,
  ArrowLeftFromLine,
  ArrowRight,
  ArrowRightFromLine,
  ArrowUpRight,
  ArrowUpRightSquare,
  AtSign,
  AtSignIcon,
  ChevronLeft as Back,
  Quote as BlockQuote,
  Book,
  Cable,
  Camera,
  ChevronDown,
  ChevronsDownUp,
  ChevronsUpDown,
  ChevronUp,
  CircleDot,
  CircleOff,
  Clock,
  X as Close,
  XSquare as CloseAll,
  CloudOff,
  Code,
  Code2 as CodeBlock,
  MessageCircle as Comment,
  Copy,
  Delete,
  BookOpen as Documentation,
  Download,
  // FilePen as Draft,
  PenSquare as Draft,
  ChevronsUpDown as Drag,
  Italic as Emphasis,
  AlertOctagon as ErrorIcon,
  ExternalLink,
  Star as Favorite,
  File,
  FileInput,
  FileOutput,
  FileText,
  FileWarning,
  Folder,
  FolderInput,
  ChevronRight as Forward,
  Globe,
  ListPlus as GroupIcon,
  Heading as HeadingIcon,
  HelpCircle as Help,
  EyeOff as Hide,
  Home,
  ImagePlus as ImageIcon,
  Info,
  Instagram,
  Library,
  Link,
  Menu,
  MoreHorizontal,
  MoveLeft,
  ArrowRight as Next,
  ListOrdered as OrderedList,
  PanelBottom,
  Clipboard as Paste,
  Pencil,
  ArrowLeft as Prev,
  Quote,
  Redo2 as Redo,
  RefreshCcw,
  RefreshCw,
  CheckCircle2 as ReleaseNotes,
  RefreshCw as Reload,
  Reply as ReplyArrow,
  Search,
  BoxSelect as SelectAll,
  Settings2 as Settings,
  Settings2,
  Share,
  ShieldX,
  SlashSquareIcon,
  Smile,
  // AsteriskSquare as SquareAsterisk,
  SquareAsterisk as SquareAsterisk,
  Star,
  Square as Statement,
  Strikethrough,
  Bold as Strong,
  Subscript,
  Superscript,
  TextCursorInput,
  Trash,
  Twitter,
  Type,
  Underline,
  Undo2 as Undo,
  Undo2,
  Unlink,
  List as UnorderedList,
  Upload,
  UploadCloud,
  User,
  UserPlus,
  UserPlus2,
  Video as VideoIcon,
  X,
  XCircle,
} from 'lucide-react'

const DefaultIconColor = '#2C2C2C'

export type IconComponent = React.FC<{color?: string; size?: number | string}>

export function TwitterXIcon(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" height="1em" width="1em" {...props}>
      <path d="M18.2048 2.25H21.5128L14.2858 10.51L22.7878 21.75H16.1308L10.9168 14.933L4.95084 21.75H1.64084L9.37084 12.915L1.21484 2.25H8.04084L12.7538 8.481L18.2048 2.25ZM17.0438 19.77H18.8768L7.04484 4.126H5.07784L17.0438 19.77Z"></path>
    </svg>
  )
}

export function HistoryIcon({
  color = 'currentColor',
  size = 20,
  ...props
}: {
  color?: string
  size?: string | number
  className?: string
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
      <g stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} clipPath="url(#a)">
        <path d="M10.832 6.982v3.01l1.505 1.504" />
        <path d="M4.098 9.241a6.771 6.771 0 1 1 .376 3.01m-.376 3.761v-3.761h3.761" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.83 0h20v20h-20z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function Check({color = DefaultIconColor, size = '1em', ...props}: {color?: string; size?: string | number}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={size} height={size} fill="none" {...props}>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth={1.2}
        d="m16.03 5.682-5.855 7.217c-.538.664-.808.995-1.175 1.016-.367.022-.672-.277-1.284-.873l-2.603-2.54"
      />
    </svg>
  )
}

export function SeedHost({color = DefaultIconColor, size = '1em', ...props}: {color?: string; size?: string | number}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 512 697" fill="none" {...props}>
      <path
        fill={color}
        d="M510.932 366.895c1.946-55.696-3.783-151.443-49.492-236.419-20.739-38.557-52.798-72.52-90.005-96.13C342.914 16.25 311.367 4.236 279.574.9a.064.064 0 0 0-.071.06.066.066 0 0 1-.072.06c-40.047-4.362-80.518 5.018-115.856 33.328-105.154 84.241-65.67 240.07 23.084 309.932.041.032.09.051.142.054.05.004.093.019.133.049 7.879 5.962 36.405 27.87 65.31 54.077a.185.185 0 0 0 .309-.123.184.184 0 0 1 .307-.124c17.773 16.101 35.708 33.839 49.093 50.506 17.479 21.764 30.866 62.362 27.743 98.162-3.553 40.742-28.489 75.27-93.109 68.753-.035-.003-.068.022-.071.057a.062.062 0 0 1-.067.058c-5.255-.508-10.774-1.289-16.568-2.363C81.094 587.679 52.605 422.767 45.137 359.759c-6.359-53.655-2.158-88.112.066-106.35 5.092-41.771 25.146-94.567 41.503-132.644 7.291-16.974-1.673-22.836-12.038-7.545C29.418 179.972 2.42 269.779.322 329.879c-1.946 55.696 3.783 151.443 49.492 236.42 20.739 38.556 52.797 72.519 90.005 96.129 28.521 18.097 60.068 30.111 91.861 33.447a.064.064 0 0 0 .071-.06.065.065 0 0 1 .072-.059c40.047 4.362 80.518-5.019 115.856-33.328 105.154-84.242 65.67-240.071-23.084-309.933a.254.254 0 0 0-.142-.054.238.238 0 0 1-.133-.049c-7.879-5.961-36.406-27.869-65.31-54.077a.185.185 0 0 0-.309.123.184.184 0 0 1-.308.124c-17.772-16.101-35.707-33.839-49.092-50.506-18.675-23.253-32.679-68.005-26.867-105.435 5.819-37.472 31.498-67.605 92.233-61.48.035.003.068-.022.07-.057a.062.062 0 0 1 .068-.058c5.255.508 10.774 1.29 16.567 2.363 138.788 25.706 167.277 190.618 174.745 253.626 6.359 53.655 2.158 88.112-.066 106.351v.003l-.003.021c-2.711 38.771-23.84 93.401-41.13 132.799-7.423 16.916 1.302 22.657 11.668 7.366 45.25-66.752 72.247-156.56 74.346-216.66Z"
      />
      <path
        fill={`#666`}
        // fill={`${color}66`}
        d="M510.932 366.895c1.946-55.696-3.783-151.443-49.492-236.419-20.739-38.557-52.798-72.52-90.005-96.13C303.863-8.53 197.441 45.976 182.434 142.62c5.819-37.471 31.498-67.604 92.233-61.48.035.004.068-.021.07-.056a.062.062 0 0 1 .068-.058c5.255.508 10.774 1.29 16.567 2.363 138.788 25.706 167.277 190.618 174.745 253.626 6.359 53.655 2.158 88.112-.066 106.351v.003l-.003.021c-2.711 38.771-23.84 93.401-41.13 132.799-7.423 16.916 1.302 22.657 11.668 7.366 45.25-66.752 72.247-156.56 74.346-216.66ZM236.449 615.748c-5.255-.508-10.774-1.29-16.568-2.363C81.094 587.679 52.605 422.767 45.137 359.759c-6.359-53.655-2.158-88.112.066-106.35 5.092-41.771 25.146-94.567 41.503-132.644 7.291-16.974-1.673-22.836-12.038-7.545C29.418 179.972 2.42 269.779.322 329.879c-1.946 55.696 3.783 151.443 49.492 236.42 20.739 38.556 52.797 72.519 90.005 96.128 58.037 36.827 180.984-13.588 189.877-115.547-3.553 40.742-28.489 75.27-93.109 68.753-.035-.003-.068.022-.071.057a.062.062 0 0 1-.067.058Z"
      />
    </svg>
  )
}

export function SelfHost({color = DefaultIconColor, size = '1em', ...props}: {color?: string; size?: string | number}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 29 28" fill="none" {...props}>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M19.834 22.75a3.957 3.957 0 0 1 2.916-2.916 3.958 3.958 0 0 1-2.916-2.917 3.96 3.96 0 0 1-2.917 2.917 3.958 3.958 0 0 1 2.917 2.916ZM6.5 9.833a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5V11.5A2.5 2.5 0 0 1 19 14H9a2.5 2.5 0 0 1-2.5-2.5V9.833Z"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M14 20.667H9a2.5 2.5 0 0 1-2.5-2.5V16.5A2.5 2.5 0 0 1 9 14h8.75M9.833 10.667v.008M9.833 17.333v.008"
      />
    </svg>
  )
}

export function PasteSetupUrl({
  color = DefaultIconColor,
  size = '1em',
  ...props
}: {
  color?: string
  size?: string | number
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 29 28" fill="none" {...props}>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M12 8.167h-1.666a1.667 1.667 0 0 0-1.667 1.667v10a1.667 1.667 0 0 0 1.667 1.666h2.5m7.5-7.5V9.834a1.667 1.667 0 0 0-1.667-1.667H17M15.333 18.167v-.834a.833.833 0 0 1 .833-.833H17m2.5 0h.833a.833.833 0 0 1 .833.833v.834m0 2.5v.833a.834.834 0 0 1-.833.833H19.5m-2.5 0h-.834a.834.834 0 0 1-.833-.833v-.833"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M12 8.167A1.667 1.667 0 0 1 13.667 6.5h1.666a1.666 1.666 0 1 1 0 3.333h-1.666A1.666 1.666 0 0 1 12 8.167Z"
      />
    </svg>
  )
}

export function Contact({
  color = DefaultIconColor,
  size = '1em',
  ...props
}: {
  color?: string
  size?: string | number
  className?: string
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={size} height={size} fill="none" {...props}>
      <path
        stroke={color}
        strokeWidth={1.2}
        d="M15.494 17.254c-.285-.886-.913-1.669-1.786-2.227-.873-.558-1.943-.861-3.044-.861-1.1 0-2.17.303-3.044.861-.873.558-1.5 1.341-1.786 2.227"
      />
      <circle cx={10.664} cy={8.334} r={2.5} stroke={color} strokeLinecap="round" strokeWidth={1.2} />
      <rect width={15.467} height={15.467} x={2.93} y={2.266} stroke={color} strokeWidth={1.2} rx={2.733} />
    </svg>
  )
}

export function Document({color = DefaultIconColor, size = '1em', ...props}: {color?: string; size?: string | number}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={size} height={size} fill="none" {...props}>
      <path
        stroke={color}
        strokeWidth={1.2}
        d="M11.724 2.5H8.247c-1.57 0-2.357 0-2.845.488s-.488 1.274-.488 2.845v8.334c0 1.571 0 2.357.488 2.845s1.274.488 2.845.488h5c1.572 0 2.357 0 2.846-.488.488-.488.488-1.274.488-2.845v-6.81c0-.34 0-.51-.064-.664-.063-.153-.184-.274-.424-.514l-3.19-3.19c-.242-.242-.362-.362-.515-.426-.153-.063-.324-.063-.664-.063Z"
      />
      <path stroke={color} strokeLinecap="round" strokeWidth={1.2} d="M8.248 10.834h5M8.248 14.166h3.333" />
      <path stroke={color} strokeWidth={1.2} d="M11.582 2.5v3.333c0 .786 0 1.179.244 1.423s.637.244 1.423.244h3.333" />
    </svg>
  )
}

export function Version({color = DefaultIconColor, size = '1em', ...props}: {color?: string; size?: string | number}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={size} height={size} fill="none" {...props}>
      <path
        fill={color}
        d="M14.062 5.278A6.171 6.171 0 0 0 3.865 9.302a.6.6 0 0 1-1.194-.121 7.371 7.371 0 1 1 1.197 4.83v2.002a.6.6 0 0 1-1.2 0V12.25a.6.6 0 0 1 .6-.6H7.03a.6.6 0 0 1 0 1.2H4.57a6.171 6.171 0 1 0 9.492-7.573Z"
      />
      <path
        fill={color}
        d="M10.02 6.535a.6.6 0 0 1 .6.6v2.191h2.193a.6.6 0 1 1 0 1.2H10.62v2.193a.6.6 0 0 1-1.2 0v-2.193H7.229a.6.6 0 0 1 0-1.2H9.42v-2.19a.6.6 0 0 1 .6-.6Z"
      />
    </svg>
  )
}

export function NoConnection(props: {color?: string; size?: string | number; className: string}) {
  const size = props.size || 100
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 77 77"
      width={size}
      height={size}
      className={props.className}
    >
      <path
        fill={props.color || DefaultIconColor}
        fillRule="evenodd"
        d="M30.273.638C15.692 3.847 3.721 15.874.64 30.411c-.8 3.778-.8 12.265 0 16.043C4.254 63.507 20.195 76.88 36.906 76.88c2.869 0 3.344-.118 3.949-.982.378-.54.688-1.335.688-1.768 0-1.215-1.62-2.553-3.094-2.553-2.925 0-6.55-5.622-8.63-13.386-1.753-6.544-2.155-6.059 5.026-6.059 5.367 0 6.209-.1 6.85-.808.966-1.067.93-2.853-.077-3.764-.674-.61-1.874-.73-7.234-.73H27.96l-.274-1.658c-.151-.911-.274-3.944-.274-6.74 0-2.795.123-5.827.274-6.739l.274-1.657h20.976l.281 2.05c.155 1.128.282 3.47.282 5.205 0 3.707.719 5.119 2.608 5.119 2.3 0 2.695-1.024 2.695-6.995v-5.38H70.29l.447 1.178c.247.647.567 3.084.712 5.414.29 4.666.83 5.783 2.797 5.783 2.05 0 2.651-1.18 2.651-5.199 0-17.027-13.237-32.945-30.426-36.588-3.66-.776-12.64-.767-16.197.015Zm5.193 6.315c-.911.916-2.31 3.012-3.107 4.658-1.454 3.004-3.63 10.266-3.63 12.127l-.002.995h19.445l-.002-.995c-.001-1.86-2.176-9.123-3.631-12.127-1.839-3.797-4.272-6.323-6.09-6.323-.945 0-1.801.477-2.983 1.665ZM23.74 8.775c-5.666 2.847-9.586 6.405-13.196 11.98-1.18 1.823-2.146 3.464-2.146 3.646 0 .182 3.259.332 7.242.332h7.242l.549-2.983c.716-3.897 2.477-9.52 3.8-12.139.58-1.146 1.054-2.19 1.054-2.32 0-.562-1.346-.123-4.544 1.484Zm24.874-1.484c0 .13.474 1.174 1.053 2.32 1.323 2.619 3.084 8.242 3.8 12.139l.55 2.983h7.241c3.984 0 7.242-.15 7.242-.332 0-.835-4.512-7.196-6.583-9.28-2.743-2.762-6.711-5.53-10.035-7-2.395-1.059-3.268-1.28-3.268-.83ZM5.792 32.834c-.268 1.539-.488 4.058-.488 5.598s.22 4.06.488 5.599l.487 2.798H22.098V30.036H6.278l-.486 2.798Zm43.111 16.13c-1.54 1.701-.98 2.714 4.572 8.251l5.303 5.29-5.303 5.315c-5.595 5.609-6.22 6.768-4.495 8.329 1.823 1.65 2.995 1.04 8.55-4.446l5.242-5.178 5.191 5.178c5.429 5.415 6.646 6.077 8.24 4.483 1.593-1.594.931-2.811-4.483-8.24l-5.178-5.19 5.178-5.243c4.295-4.348 5.177-5.468 5.177-6.569 0-.73-.364-1.656-.808-2.058-1.69-1.528-2.695-.971-8.252 4.572l-5.316 5.304-5.29-5.303c-5.587-5.602-6.756-6.233-8.328-4.496Zm-40.505 3.5c0 .182.959 1.827 2.13 3.655 2.65 4.136 5.945 7.465 10.024 10.128 3.124 2.039 7.14 3.86 7.568 3.432.124-.123-.263-1.188-.859-2.367-1.35-2.67-3.108-8.268-3.83-12.197l-.55-2.983H15.64c-3.983 0-7.242.15-7.242.332Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export function Macos(props: {color?: string; size?: string | number}) {
  const size = props.size || '1em'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 51 51" fill="none" {...props}>
      <path
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.604}
        d="M17.45 15.323c-6.7 0-8.929 6.73-8.929 12.333 0 6.727 4.465 16.817 8.93 16.817 2.427-.104 3.748-1.12 6.695-1.12 2.93 0 3.348 1.12 6.696 1.12s8.93-6.727 8.93-11.21c-.063-.023-5.52-.904-5.582-6.73-.041-4.864 5.394-6.623 5.582-6.725-2.284-3.345-6.588-4.402-7.813-4.485-3.198-.25-6.317 2.244-7.813 2.244-1.518 0-4.241-2.244-6.695-2.244ZM25.189 9.056a4.167 4.167 0 0 0 4.166-4.166 4.167 4.167 0 0 0-4.166 4.166Z"
      />
    </svg>
  )
}

export function Win32(props: {color?: string; size?: string | number}) {
  const size = props.size || '1em'
  return (
    <svg width={size} height={size} viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.2715 42.3892L12.2715 39.2642C10.1882 39.0559 8.52148 37.3892 8.52148 35.3059V16.1392C8.52148 14.0559 10.1882 12.3892 12.2715 12.1809L37.2715 9.05588C39.7715 8.84755 41.8548 10.7225 41.8548 13.0142V38.2225C41.8548 40.7225 39.5631 42.5975 37.2715 42.1809V42.3892Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="2.60417"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1885 11.1396V40.3063"
        stroke={props.color || 'currentColor'}
        strokeWidth="2.60417"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.52148 25.7229H41.8548"
        stroke={props.color || 'currentColor'}
        strokeWidth="2.60417"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Linux(props: {color?: string; size?: string | number}) {
  const size = props.size || '1em'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" {...props}>
      <path
        fill={props.color || 'currentColor'}
        fillRule="evenodd"
        d="M24.084 5.882c-.371.08-.991.276-1.378.437-2.532 1.053-3.276 2.994-2.903 7.571.161 1.972.166 4.546.01 5.09-.071.25-.657 1.132-1.563 2.351-.796 1.074-1.558 2.14-1.693 2.37-.345.588-.781 1.65-1.467 3.57-.326.913-.773 2.04-.992 2.505-.32.676-.409.987-.445 1.537-.025.38-.001.817.053.972.09.257.069.304-.232.544-.18.145-.461.497-.622.783-.518.916-1.103 1.3-2.495 1.633-1.623.389-1.927.856-1.54 2.366.244.952.222 1.241-.197 2.592-.19.61-.272 1.037-.232 1.198.157.623 1.14 1.089 2.884 1.363 1.7.268 2.374.44 4.044 1.028 2.047.722 2.908.944 3.654.941.87-.003 1.482-.333 2.031-1.094.172-.239.305-.286 1.252-.446 2.536-.428 4.794-.44 7.01-.036l.845.154.336.507c.593.893 1.45 1.288 2.541 1.174.781-.082 1.328-.344 2.038-.978.81-.723 1.839-1.397 3.654-2.397 2.792-1.538 3.105-1.799 3.122-2.611.012-.568-.234-.878-1.06-1.332-1.15-.633-1.574-1.21-1.578-2.145-.003-.67-.236-1.399-.606-1.892l-.311-.413.16-.77c.21-1.01.224-2.966.027-3.806-.33-1.41-1.79-3.971-4.337-7.61-.834-1.192-1.616-2.384-1.737-2.649-.396-.863-.522-1.58-.618-3.516-.162-3.245-.395-4.452-1.171-6.069-.495-1.03-1.444-2.011-2.39-2.473-1.179-.574-2.718-.743-4.094-.45Zm1.915 5.13c-.72.327-1.181 1.158-1.189 2.145-.005.746.113 1.008.534 1.184.464.194.55.186.429-.04-.227-.423-.039-1.223.373-1.59.25-.223.786-.248 1.027-.049.093.077.252.327.353.556.224.505.166 1.011-.175 1.513l-.232.341.216.083c.17.066.275.029.49-.171 1.143-1.064.883-3.365-.448-3.97-.508-.23-.875-.23-1.378-.002Zm-4.623.295c-.303.123-.765.73-.902 1.186-.212.707-.15 1.557.159 2.173.157.315.383.605.535.688.25.137.277.13.528-.12.244-.244.249-.264.067-.264-.282 0-.68-.463-.805-.94-.305-1.15.638-1.938 1.265-1.06.18.252.223.439.223.95v.637l.298-.227c.164-.125.343-.228.397-.228.157 0 .228-.703.126-1.241-.122-.642-.3-.974-.723-1.345-.356-.312-.741-.381-1.168-.21Zm1.775 3.88c-1.108.774-1.896 1.472-1.902 1.685-.004.12.148.388.343.603.473.524 1.722 1.348 2.042 1.348.334 0 1.136-.389 2.569-1.244 1.348-.805 1.438-.882 1.353-1.15-.09-.285-.52-.52-1.958-1.07-1.521-.582-1.831-.603-2.447-.173Zm4.388 2.565a30.39 30.39 0 0 0-1.627.88c-1.447.834-1.956 1.056-2.433 1.057-.577.001-1.241-.363-2.044-1.12l-.675-.637v.474c0 .933-.52 2.371-1.192 3.294-.479.657-.695 1.129-1.28 2.795-.29.827-.747 1.936-1.015 2.464-.267.529-.548 1.136-.624 1.349-.427 1.202-.557 3.12-.274 4.062.22.735.7 1.256 2.458 2.67 1.829 1.47 2.216 1.908 2.216 2.502 0 .514-.273.96-.687 1.125-.178.07-.34.14-.359.155-.057.043 1.555 1.814 1.716 1.885.238.104 2.572.088 3.52-.025a14.082 14.082 0 0 0 1.438-.247c1.17-.297 2.473-1.114 3.533-2.215l.636-.661.052-1.927c.033-1.243.095-2.02.173-2.189.147-.318.641-.502 1.162-.432.36.048.375.038.47-.302.055-.194.15-.856.21-1.472.187-1.888-.039-3.182-1.038-5.938-1.035-2.855-3.293-7.748-3.601-7.802-.08-.014-.41.1-.735.255Zm-13.52 16c-.104.104-.34.488-.524.853-.462.92-.725 1.113-1.86 1.371-.518.118-1.104.295-1.302.395-.326.163-.361.217-.361.562 0 .21.05.675.112 1.034.103.606.093.718-.145 1.548-.141.492-.256 1.068-.256 1.28 0 .348.032.4.327.523.18.075 1.058.268 1.95.428 1.922.345 1.872.33 3.406.947 1.986.797 3.099 1.057 3.612.843.394-.165 1.057-.906 1.201-1.344.226-.685-.088-1.49-1.034-2.648-.314-.384-.957-1.326-1.428-2.093-1.568-2.552-1.96-3.11-2.462-3.507-.546-.432-.935-.493-1.235-.193Zm18.206.626c-.089.107-.102.508-.05 1.613.073 1.592.01 2.28-.397 4.313-.265 1.324-.251 1.894.061 2.506.647 1.269 1.78 1.17 3.419-.297 1.025-.918 1.295-1.096 3.14-2.07.865-.456 1.695-.916 1.842-1.021.523-.372.245-.856-.793-1.382-.837-.424-1.23-1.095-1.321-2.246-.038-.48-.112-.773-.232-.916-.15-.178-.189-.188-.263-.065-.813 1.345-1.782 1.894-3.201 1.814-.597-.034-.693-.07-.998-.365-.376-.364-.493-.657-.588-1.473-.058-.492-.09-.554-.283-.554a.492.492 0 0 0-.336.143Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
